import React, { Component } from "react";

export default class ViewportFix extends Component {
	
	constructor(){
		super();
		this.handleResize = this.handleResize.bind(this);
		this.state={
			width:0,
			height:0,
		}
  	}
  	
  	componentDidMount() {
	  	window.addEventListener('resize', this.handleResize);
	  	this.handleResize();
	  	setTimeout(() => {
		  	this.handleResize();
	  	}, 400);
  	}
  	
  	componentWillUnmount() {
  		window.removeEventListener('resize', this.handleResize);
  	}
  	
  	handleResize() {
	  	let screenWidth = window.innerWidth;
	  	let screenHeight = window.innerHeight;
	  	if (screenWidth !== this.state.width && this.state.height !== 0 && document.getElementsByTagName( 'html' )[0].classList.contains('state-touch')) {
		  	if (this.state.height > screenHeight) {
		  		let vh = screenHeight * 0.01;
		  		document.documentElement.style.setProperty('--vh', `${vh}px`);
		  		this.setState({width:screenWidth, height:screenHeight});
		  	}
	  	} else if (document.getElementsByTagName( 'html' )[0].classList.contains('state-touch') === false) {
		  	let vh = screenHeight * 0.01;
		  	document.documentElement.style.setProperty('--vh', `${vh}px`);
		  	this.setState({width:screenWidth, height:screenHeight});
		} else if (this.state.height === 0) {
			let vh = screenHeight * 0.01;
		  		document.documentElement.style.setProperty('--vh', `${vh}px`);
		  		this.setState({width:screenWidth, height:screenHeight});	
	  	} else {
		  	let vh = this.state.height * 0.01;
		  	document.documentElement.style.setProperty('--vh', `${vh}px`);
	  	}
	  	let rvh = screenHeight * 0.01;
	  	document.documentElement.style.setProperty('--rvh', `${rvh}px`);
  	}
  	
  	render () {
	  	
  		return <div></div>;
	
	}
}  